﻿﻿export interface ICommunicationLogRequest {
    id: number;
    productCenterId: number;
    centerId: number;
    reportedByContactId: number;
    logDateTime: Date;
    summary: string;
    notes: string;
    contacts: number[];
}
